__turbopack_context__.v({
  "footer": "Footer-module-scss-module__kQc2fa__footer",
  "footerCopyright": "Footer-module-scss-module__kQc2fa__footerCopyright",
  "footerInner": "Footer-module-scss-module__kQc2fa__footerInner",
  "footerLogo": "Footer-module-scss-module__kQc2fa__footerLogo",
  "footerLogos": "Footer-module-scss-module__kQc2fa__footerLogos",
  "footerSection": "Footer-module-scss-module__kQc2fa__footerSection",
  "logoImage": "Footer-module-scss-module__kQc2fa__logoImage",
});
